module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_8003.0f7ed521.png";